// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2rM1Z","approved":"Status_approved__1LB5Y","rejected":"Status_rejected__2K2sk","expired":"Status_expired__1iIFc","label":"Status_label__2aA7S"};